import React, { useState } from 'react';
import '../smart-policy-modal/smart-policy-modal.scss';
import { PolicyActionButtons } from '../policy-modal/policy-action-buttons';
import { PolicySummary } from '../../policy-summary/policy-summary';
import { FwVersionInfo } from '../../../../dtos/version.dto';

interface SmartReadyPolicySummaryProps {
    selectedVersion?: FwVersionInfo;
    setIsApply: (apply: boolean) => void;
    closeModal: () => void;
}

export const SmartReadyPolicySummary: React.FC<SmartReadyPolicySummaryProps> = ({ selectedVersion, setIsApply, closeModal }) => {
    const [isLoading, setIsLoading] = useState(false);

    return <div className="policy-content">
        <div
            className="policy-title">Policy Summary
        </div>
        {selectedVersion && <PolicySummary comments={selectedVersion.comments} connectionId={selectedVersion.sid} externalId={selectedVersion.externalId} />}
        <PolicyActionButtons isLoading={isLoading}
                             setIsLoading={setIsLoading}
                             setIsApply={setIsApply}
                             closeModal={closeModal}
                             buttonLocation="smartReadyPolicySummary"
                             />
    </div>;
};
